import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './routes';

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [userId, setUserId] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(null);

  const handleLogin = (id: string, name: string) => {
    setUserId(id);
    setUsername(name);
    setIsLoggedIn(false);
  };

  // Simulasi data percakapan
  const conversationID = "100";
  const conversationType = 0;

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', {
          cache: 'no-store',
          headers: { 'cache-control': 'no-cache' },
        });
  
        const data = await res.json();
  
        const current = localStorage.getItem('app_version');
        const reloaded = localStorage.getItem('app_reloaded');
  
        // Kalau versi beda DAN belum pernah reload → reload 1x
        if (current && data.version !== current && !reloaded) {
          localStorage.setItem('app_reloaded', 'true');
          window.location.reload();
        }
  
        // Simpan versi terbaru
        localStorage.setItem('app_version', data.version);
  
        // Reset flag kalau versi sudah cocok
        if (data.version === current) {
          localStorage.removeItem('app_reloaded');
        }
      } catch (e) {}
    };
  
    // Cek saat load
    checkVersion();
  
    // Cek saat user kembali ke tab
    const onFocus = () => checkVersion();
    window.addEventListener('focus', onFocus);
  
    return () => window.removeEventListener('focus', onFocus);
  }, []);  

  return (
    <BrowserRouter>
      <Router
        isLoggedIn={isLoggedIn}
        userId={userId}
        username={username}
        conversationID={conversationID}
        conversationType={conversationType}
        handleLogin={handleLogin}
      />
    </BrowserRouter>
  );
};

export default App;
